import {eachWordCapOrAllCap} from './../../../utils/FormUtils/FirstCap';
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/dot-notation */

export const filterOCRData = (data: any): any => {
  let fields;
  if (data.fields) {
    fields = Object.entries(data?.fields).map(([key, value]: any[]) => {
      if (Array.isArray(value)) {
        const mainObj = value.map((item: any) => {
          const {geometry, confidence_score, ...rest} = item;
          const {BoundingBox, Polygon} = geometry;

          return {
            value: rest,
            polygon: {
              score: confidence_score,
              value: Polygon,
              page: geometry?.Page ?? 1
            },
            boundingBox: {
              Width: BoundingBox.Width * 100,
              Height: BoundingBox.Height * 100,
              Left: BoundingBox.Left * 100,
              Top: BoundingBox.Top * 100,
              percent: confidence_score,
              page: geometry?.Page ?? 1
            }
          };
        });

        return {
          name: key,
          value: mainObj.flatMap((item: any) => {
            return item.value;
          }),
          boundingBox: mainObj.flatMap((item: any) => {
            return item.boundingBox;
          }),
          polygon: mainObj.flatMap((item: any) => {
            return item.polygon;
          })
        };
      } else {
        const {confidence_score, ...rest} = value;
        const geometry = value?.geometry;

        return {
          name: key,
          ...rest,
          polygon:
            geometry?.Polygon?.length > 0
              ? {
                  score: confidence_score,
                  value: geometry?.Polygon,
                  page: geometry?.Page ?? 1
                }
              : undefined,
          boundingBox: geometry?.BoundingBox
            ? {
                Width: geometry?.BoundingBox.Width,
                Height: geometry?.BoundingBox.Height,
                Left: geometry?.BoundingBox.Left,
                Top: geometry?.BoundingBox.Top,
                percent: confidence_score,
                page: geometry?.Page ?? 1
              }
            : null
        };
      }
    });
  } else {
    fields = [];
  }

  return {
    ...data,
    fields
  };
};

export const isEmpty = (obj: any): boolean => {
  for (const prop in obj) {
    if (Object.hasOwn(obj, prop)) {
      return false;
    }
  }

  return true;
};

export const tableColumnMap = (data: any[]): any[] => {
  const uniqueKeys = Array.from(new Set(data.flatMap(Object.keys)));

  // Step 2: Map over the unique keys to create the desired structure
  return uniqueKeys.map((key) => ({
    title: eachWordCapOrAllCap(key.replace('_', ' ')),
    dataIndex: key
  }));
};
